import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyLevelFormManagementServices = {
  //Study Level Form
  addNewStudyLevelForm,
  addNewStudyLevelFormWithFile,
  pullGlobalForminStudyLevelForm,
  duplicateStudyLevelForm,
  updateStudyLevelForm,
  digitalSignatureStudyLevelForm,
  addUpdateStudyLevelFormFields,
  addUpdateStudyLevelAppFormFields,
  deleteStudyLevelForm,
  softDeleteRestoreStudyLevelForm,
  getStudyLevelForm,
  getStudyLevelFormReviewHistory,
  getStudyLevelFormFieldsByVersion,
  getStudyLevelFormBasedOnFieldKey,
  getHeighestVersionStudyLevelFormHistory,
  getStudyLevelFormAuditTrials,

  //Study Level Custom Edit Check Metadata
  addNewStudyLevelCustomEditCheck,
  updateStudyLevelCustomEditCheck,
  duplicateStudyLevelCustomEditCheck,
  deleteStudyLevelCustomEditCheck,
  softDeleteRestoreStudyLevelCustomEditCheck,
  getStudyLevelCustomEditCheck,
  getStudyLevelDerivedVariable,

  //Study Level Field Check Notification Metadata
  addNewStudyLevelFieldCheckNotification,
  updateStudyLevelFieldCheckNotification,
  duplicateStudyLevelFieldCheckNotification,
  deleteStudyLevelFieldCheckNotification,
  softDeleteRestoreStudyLevelFieldCheckNotification,
  getStudyLevelFieldCheckNotification,
};

// Get Study Level Form
async function getStudyLevelForm(studyId, category, status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelForm/${studyId}/${category}/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelForm/${studyId}/${category}/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Level Form Review History
async function getStudyLevelFormReviewHistory(studyId, formId, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelFormReviewHistory/${studyId}/${formId}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelFormReviewHistory/${studyId}/${formId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Level Form
async function addNewStudyLevelForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyLevelForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Add New Study Level Form With File
async function addNewStudyLevelFormWithFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyLevelFormWithFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}


// Pull Global Form in Study Level Form
async function pullGlobalForminStudyLevelForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}pullGlobalForminStudyLevelForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Duplicate Study Level Form
async function duplicateStudyLevelForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateStudyLevelForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Level Form
async function updateStudyLevelForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyLevelForm`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Sent Study Level Form for Quality Check
async function digitalSignatureStudyLevelForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}digitalSignatureStudyLevelForm`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Level Form Fields
async function addUpdateStudyLevelFormFields(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateStudyLevelFormFields`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Level App Form Fields
async function addUpdateStudyLevelAppFormFields(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateStudyLevelAppFormFields`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Level Form
async function softDeleteRestoreStudyLevelForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyLevelForm`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Level Form
async function deleteStudyLevelForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyLevelForm`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Level Form Audit Trial
async function getStudyLevelFormAuditTrials(studyId, formId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyLevelFormAuditTrials/${studyId}/${formId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Level Form Heighest Version
async function getHeighestVersionStudyLevelFormHistory(studyId, formId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getHeighestVersionStudyLevelFormHistory/${studyId}/${formId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Level Form Fields By Version
async function getStudyLevelFormFieldsByVersion(studyId, formId, version) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyLevelFormFieldsByVersion/${studyId}/${formId}/${version}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Level Form Based on Form Field
async function getStudyLevelFormBasedOnFieldKey(formType, studyId, formId, fieldName) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyLevelFormBasedOnFieldKey/${formType}/${studyId}/${formId}/${fieldName}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Add New Study Level Custom Edit Check
async function addNewStudyLevelCustomEditCheck(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyLevelCustomEditCheck`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Duplicate Study Level Custom Edit Check
async function duplicateStudyLevelCustomEditCheck(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateStudyLevelCustomEditCheck`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Level Custom Edit Check
async function updateStudyLevelCustomEditCheck(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyLevelCustomEditCheck`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Level Custom Edit Check
async function deleteStudyLevelCustomEditCheck(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyLevelCustomEditCheck`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Level Custom Edit Check
async function softDeleteRestoreStudyLevelCustomEditCheck(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyLevelCustomEditCheck`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Level Custom Edit Check
async function getStudyLevelCustomEditCheck(studyId, status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelCustomEditCheck/${studyId}/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelCustomEditCheck/${studyId}/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Level Derived Variable
async function getStudyLevelDerivedVariable(studyId, status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelDerivedVariable/${studyId}/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelDerivedVariable/${studyId}/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Level Field Check Notification
async function addNewStudyLevelFieldCheckNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyLevelFieldCheckNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Duplicate Study Level Field Check Notification
async function duplicateStudyLevelFieldCheckNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateStudyLevelFieldCheckNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Study Level Field Check Notification
async function updateStudyLevelFieldCheckNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyLevelFieldCheckNotification`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Level Field Check Notification
async function deleteStudyLevelFieldCheckNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyLevelFieldCheckNotification`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Level Field Check Notification
async function softDeleteRestoreStudyLevelFieldCheckNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyLevelFieldCheckNotification`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Level Field Check Notification
async function getStudyLevelFieldCheckNotification(studyId, status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelFieldCheckNotification/${studyId}/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLevelFieldCheckNotification/${studyId}/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}